import { StandardOption } from './Component';

export enum EntityListActionId {
  Move = 'move',
  Delete = 'delete',
  Share = 'share',
  Edit = 'edit',
  ToAdmin = 'to-admin',
  ToMember = 'to-member',
  ToChannel = 'to-channel',
  Approve = 'approve',
  Reject = 'reject',
  ReInvite = 'reinvite',
  Disable = 'disable',
  Enable = 'enable',
  UnDelete = 'undelete',
  Purge = 'purge',
  Remove = 'remove',
  Activate = 'activate',
  ResendLink = 'resend-link',
  SetRetention = 'set-retention',
  RemoveRetention = 'remove-retention',
}

export type EntityListAction<E extends Entity> = {
  id: EntityListActionId;
  predicate?: Predicate<E>;
  confirm?: (isBulk: boolean, entities: E[]) => Promise<boolean>;
  pure?: boolean;
  process: (entities: E[]) => Promise<unknown>;
  disableBulk?: boolean;
} & StandardOption;
